import React from "react";
import { LogOut, User } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "../components/ui/dropdown-menu";
import { Avatar, AvatarFallback } from "../components/ui/avatar";
import { ROLE_LABEL, rolesFor } from "../lib/permissions";

function initials(name = "") {
  return name.split(" ").filter(Boolean).slice(0, 2).map((s) => s[0]).join("").toUpperCase() || "?";
}

export function TopHeader({ user, onLogout, pageTitle }) {
  const roleText = rolesFor(user).map((role) => ROLE_LABEL[role] || role).join(", ");
  return (
    <header
      className="h-14 border-b border-border bg-card/80 backdrop-blur-md sticky top-0 z-30 px-4 lg:px-6 flex items-center justify-between gap-4"
      data-testid="top-header"
    >
      <div className="flex items-center gap-3 min-w-0 flex-1">
        <span className="text-sm font-medium text-muted-foreground truncate" data-testid="header-page-title">{pageTitle}</span>
      </div>

      <div className="flex items-center gap-2">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button className="flex items-center gap-2 pr-2 pl-1 py-1 rounded-md hover:bg-accent" data-testid="header-user-menu-btn">
              <Avatar className="w-7 h-7">
                <AvatarFallback className="text-[11px] bg-foreground text-background">{initials(user?.name)}</AvatarFallback>
              </Avatar>
              <div className="hidden sm:block text-left leading-tight">
                <div className="text-xs font-medium" data-testid="header-user-name">{user?.name}</div>
                <div className="text-[10px] uppercase tracking-wider text-muted-foreground" data-testid="header-user-role">{roleText}</div>
              </div>
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-56">
            <DropdownMenuLabel>
              <div className="flex flex-col">
                <span className="text-sm">{user?.name}</span>
                {user?.title && <span className="text-xs font-normal">{user.title}</span>}
                <span className="text-xs font-normal text-muted-foreground">{user?.email}</span>
              </div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem disabled>
              <User className="w-3.5 h-3.5 mr-2" /> {roleText}
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={onLogout} data-testid="header-logout-btn" className="text-destructive focus:text-destructive">
              <LogOut className="w-3.5 h-3.5 mr-2" /> Sign out
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
}
